export default "/react/sambaIcon-c850d11d.svg";